export const VIEW_SET_SPINNER = 'VIEW_SET_SPINNER';
export const VIEW_SET_HOMEPAGE_KEY = 'VIEW_SET_HOMEPAGE_KEY';
export const VIEW_SET_MODEL = 'VIEW_SET_MODEL';
